import React, { useCallback, useMemo } from 'react';
import { isSafari } from 'react-device-detect';
import PropTypes from 'prop-types';
import { getIsFieldRequired } from 'utils';

import { get } from '@atlas/core';
import { PasswordInput } from '@atlas/ui';

import Field from 'common/Form/Field';

const PasswordField = ({ field, onBlur = () => {}, onChange, onFocus = () => {} }) => {
  const {
    active,
    autocomplete,
    autofocus,
    disabled,
    errors,
    label,
    name,
    placeholder,
    rules,
    touched,
    value,
    warnings,
  } = field;
  const inputValue = value ?? '';
  const changeHandler = useCallback(event => onChange(event.target.value), [onChange]);
  const error = touched && errors[0];
  const warning = touched ? get(warnings, '[0].message') : null;
  const success = touched && !error;

  const isRequiredSymbol = useMemo(() => getIsFieldRequired(rules), [rules]);

  return (
    <Field className="field-password" isSignupForm options={field}>
      <PasswordInput
        active={active}
        autoComplete={autocomplete}
        autoFocus={autofocus}
        disabled={disabled}
        error={error}
        isRequiredSymbol={isRequiredSymbol}
        isTypeText={isSafari}
        label={label}
        name={name}
        onBlur={onBlur}
        onChange={changeHandler}
        onFocus={onFocus}
        placeholder={placeholder}
        success={success}
        touched={touched}
        value={inputValue}
        warning={warning}
      />
    </Field>
  );
};

PasswordField.propTypes = {
  field: PropTypes.object.isRequired,
  onBlur: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
};

export default PasswordField;
